import { BoatIconSvg } from "../../../../assets/svg";
import { splitDate } from "../../../../utils/splitDate";
import dayjs from "dayjs";
import "./style.scss";

interface IItineraryTable {
  portDetails: any;
}

const ItineraryTable:React.FC<IItineraryTable> = ({portDetails}) => {
  return (
    <div className="itinerary-table-wrapper flex flex-col">
      {portDetails?.map((portData: any, index: number) => {
        return (
          <div className="itinerary-table-row flex gap-4" key={index}>
            <span className="day-col">Day {`${index + 1}`.padStart(2, '0')}</span>
            <div className="mb-5">
              <div className="flex gap-2">
                <BoatIconSvg/>
                <span className="transit-event">{portData?.name}</span>
              </div>
              {portData?.departure_time && <span className="transit-event-date">{dayjs(splitDate(portData?.departure_time)).format("DD MMM YYYY")}</span>}
            </div>
            {/* {!!data.events.length && <div className="strike-div">━━━</div>}
            {!!data.events.length &&
              data.events?.map((event, index) => {
                return (
                  <>
                    <div key={index} className="event-wrapper flex flex-col">
                      <span className="transit-event">{event.eventName}</span>
                      <span className="transit-event-date">{event.eventDate}</span>
                    </div>
                    {data.events.length !== index + 1 && <div className="strike-div">━━━</div>}
                  </>
                );
              })} */}
          </div>
        );
      })}
    </div>
  );
};

export default ItineraryTable;
